var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 216,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    d: "M208 48a88.5 88.5 0 0 0-51-37c-8-2.2-16.3-3.4-24.6-3.7-54-2-73.9 42.5-91.3 54C23.7 72.7-3.1 92.3.3 133.5a87.1 87.1 0 0 0 64.2 78.7c7.8 2.1 15.8 3.3 23.9 3.7 24.6 1 44.6-4.9 64.2-19.8 4.5-3.5 9-7.4 15-7.8 4.2-.3 8.3 1.2 3.8 5.4-5.2 4.8.8 14.4 14.2 7.7 22.3-11 31.6-35 35.9-59.3 5.3-30 2.7-67-13.5-94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M208 48a88.5 88.5 0 0 0-51-37c-8-2.2-16.3-3.4-24.6-3.7-54-2-73.9 42.5-91.3 54C23.7 72.7-3.1 92.3.3 133.5a87.1 87.1 0 0 0 64.2 78.7c7.8 2.1 15.8 3.3 23.9 3.7 24.6 1 44.6-4.9 64.2-19.8 4.5-3.5 9-7.4 15-7.8 4.2-.3 8.3 1.2 3.8 5.4-5.2 4.8.8 14.4 14.2 7.7 22.3-11 31.6-35 35.9-59.3 5.3-30 2.7-67-13.5-94Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    d: "m93.3 208.3-5.3-.1a100.7 100.7 0 0 1-32.6-7 78.5 78.5 0 0 1-47.8-67.7 58.5 58.5 0 0 1 10.8-41.1c7.3-9.9 17-17 26.3-23.1 6.2-4 11.6-10.1 18-17.2C77.4 35.6 95.8 15 129.6 15h3.1c7.7.4 15.4 1.5 22.8 3.6a80.2 80.2 0 0 1 46 33.1c16.3 27 17.1 64 12.6 89.7-4.5 25.5-13 41.7-26.2 50.4-.1-1-.4-1.9-.7-2.8-2.4-6-8.4-9.5-16.2-9.5h-2c-9.3.8-16 6-20.9 9.7l-1.2 1a83.5 83.5 0 0 1-53.7 18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M166.3 42.7a2.2 2.2 0 1 0 0-4.3 2.2 2.2 0 0 0 0 4.3ZM203 79.8a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4ZM51.5 183.5a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4ZM185 181.6a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4ZM113 21.5a1.2 1.2 0 0 1-1.4 1.2 1.3 1.3 0 0 1-.5-2.2 1.3 1.3 0 0 1 2 1ZM25.9 99.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4ZM184 43.3a1 1 0 1 0 0-2.2 1 1 0 0 0 0 2.2ZM37.6 167.8a1 1 0 1 0 0-2.2 1 1 0 0 0 0 2.2ZM198.2 158.8a1 1 0 1 0 0-2.2 1 1 0 0 0 0 2.2ZM98 187.7a1 1 0 1 1-2.2 0 1 1 0 0 1 2.2 0ZM42.2 149.4a1 1 0 0 1-.6 1 1.1 1.1 0 0 1-1.5-.8 1 1 0 0 1 1-1.3 1 1 0 0 1 1.1 1ZM87.3 201.4a1 1 0 0 1-1.9.8 1 1 0 1 1 1.9-.8ZM150 26.5a1 1 0 1 1-2.3 0 1 1 0 0 1 2.2 0ZM151.8 145.2a1 1 0 0 1-1.3 1 1 1 0 0 1 .2-2.1 1 1 0 0 1 1.1 1ZM201.8 103a1 1 0 1 1-2.2 0 1 1 0 0 1 2.2 0ZM23.7 145.7a1 1 0 1 0 0-2.2 1 1 0 0 0 0 2.2ZM120.6 194.9a1 1 0 1 0 0-2.2 1 1 0 0 0 0 2.2ZM81.2 152.5a1 1 0 1 0 0-2.1 1 1 0 0 0 0 2.1ZM153.7 63.8a1 1 0 0 1-1.3 1 1 1 0 0 1-.8-.8 1 1 0 1 1 2.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M92.3 119.8c.5 3.8.7 7.5.7 11.3 0 5.7 1.3 5.8 4 6.5 2.8.6 7.4-3 8.6-6.8 1.2-3.7 1-10.8 1-10.8l-14.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M104.8 126.7c-.2 2.5-1 6.6-4.7 8.6a6.7 6.7 0 0 1-6.7-.3c.5 2 1.7 2.1 3.6 2.6 2.7.6 7.4-3 8.6-6.8 1.2-3.7 1-10.8 1-10.8H105l-.2 6.7ZM79.4 125.2c3.6-.3 7.2-1 10.6-2.3 6.1-2.3 13-7.4 11.5-12.4s-9.4-6.4-12.6-6c-2.3.2-4.5.6-6.8 1.2 0 0 .8 14-2.7 19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M76.5 127.2c2.5-.6 4.8-2 6.4-4 2.5-3.2 3.4-8.3 2-11.7-1.3-3.4-8.4 15.7-8.4 15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M52.3 94.4s-2.4 11.2 2.2 22.2c4.7 11 14.8 13.7 21.9 10.6 7.1-3 8.8-13 8.9-19.6l-.1-9.6s-24 2.3-33-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M51.4 91.3s-1 3.7 1.1 5a38.5 38.5 0 0 0 26.3 5.4c7.3-1.4 5.7-3.5 5.6-4.7-.1-1.2-33-5.7-33-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M49.6 79.7s.4 9.1 1.8 11.6a51 51 0 0 0 30.7 8c9.9-2.2 26-11 27.9-17.4 2-6.4-3.2-16.6-8-21.4-4.7-4.9-6.8-5.9-6.8-5.9S83.5 70.2 68.9 75.4c-14.5 5.1-19.3 4.3-19.3 4.3ZM127 102.7s10.3-4 14.4-1.6c4 2.5 7.2 8.3 9.4 17.1 2.2 9-4.2 15.5-9.6 15.3-5.5-.3-4.5-3.8-6.7-7.4-2-3.6-4.7-5.7-4.9-6-.1-.5 2.5-11.9-2.7-17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M141.4 101.1a8 8 0 0 0-4.3-.7c2 1.5 6.2 5.3 8.9 12.4 3.7 10 2 15.2.1 17.1-2 2-6 2.6-7.7 2.4h-1c.8.7 1.9 1.1 3.8 1.2 5.4.2 11.8-6.3 9.6-15.2-2.2-9-5.3-14.7-9.4-17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M105.2 128s9.7 2.7 18.7-1c9.1-3.5 14.4-9.5 12.4-16.9-2-7.3-5.7-7.6-14-7.5-8.2.1-9.8.8-9.8.8s-.3 20.8-7.3 24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M115.9 92.9c.9-10-5.8-18.6-14.9-19.5-9.1-.8-17.3 6.5-18.2 16.4-1 9.8 5.7 18.5 14.8 19.4 9.2.9 17.3-6.5 18.3-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M119.4 113.6c.8-9-5.2-16.8-13.5-17.6-8.3-.8-15.7 5.8-16.5 14.8-.9 9 5.1 16.9 13.4 17.6 8.3.8 15.7-5.8 16.6-14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M117.3 103s.7-14.6-6.4-22.5c-7.1-8-23.3-1.5-26 10.5-2.6 11.9 3 29.8 10.4 34.4 7.4 4.7 13.7.1 18-6.3 4.1-6.4 4-16.2 4-16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M17 62.3S11.4 76 10 79.8a39.6 39.6 0 0 0-2.8 10.7c0 2.5 1.6 5.7 2.8 5.8 1.2.1 2-.7 2.2-2.4.2-1.7.1-2.4 1-3.3 1.2-1.1 2.5-2.1 3.9-3 .3-.1.6 1.2-.2 2.6-.8 1.4-2.6 2.7-1.5 4.1 1 1.4 3.3-.2 4.5-1.5 1.4-1.5 2.4-3.3 2.9-5.3.5-2.1.2-6.5.2-6.5l10-9.4s-13.1-1.5-16-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M17.6 89s-.1 2 3.5 2M8.1 87.4a4.5 4.5 0 0 0 5.2 3.2M7.7 92.6s2.5 2 4.3-.1M12.8 74s-.3 7.4 10.3 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M19.8 58.3s-2.6 0-2.8 4c-.2 4 3 10.1 9.2 11.1 6.1 1 9.9-2.6 11-5.6 1.1-3-13.2-11.8-17.4-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M26.7 47.5s-6.5 7.8-7.6 11.7c-1.2 4 1.7 11.3 8.9 12.1 7.2 1 11.4-5 11.4-5L26.7 47.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M30.4 41.2a15.5 15.5 0 0 0-5 10.2c-.3 6.4 5.6 13.7 13.2 13 7.7-.7-1.9-23.5-8.2-23.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M33.6 45.9s-3.4 4-1.5 11c1.2 4 3.6 7.8 6.9 10.6 0 0 9.4 13.5 13.3 15.6 4 2.1 11 2.2 25.1-3.6a39.8 39.8 0 0 0 22-18.4c2.1-4.3-10.6-24.2-15-27A23.1 23.1 0 0 0 70 30.5c-2.7.4-5.4.9-8 1.5L33.5 46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M31 43.6s-3.3 4.1-1.4 11c1.2 4.1 3.6 7.8 6.8 10.7 0 0 9.5 13.4 13.4 15.5 4 2.1 11 2.2 25.1-3.5a39.8 39.8 0 0 0 22-18.5c2.1-4.3-10.6-24.2-15-27a23.1 23.1 0 0 0-14.3-3.4c-2.8.3-5.4.8-8 1.5L31 43.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M65.1 35.9a21.4 21.4 0 1 0-41-11.7 21.4 21.4 0 0 0 41 11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCC0C0",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M60.4 39.4a24.2 24.2 0 0 0-38-29.9 24.2 24.2 0 0 0 38 29.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B575B",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M58 28c.4-.9.6-1.8.5-2.6-.1-1.8-2.2-5.2-3-6.1-.8-.9-2.2.2-2.2.2l-1.5-2.7a13.5 13.5 0 1 0-23.5 13l3 5.6-1.7-2.8s-1.5.6-1.2 1.8a15 15 0 0 0 3.5 5.7c.8.6 1.7 1 2.6 1l4.1 7.3a24.5 24.5 0 0 0 24-12.3L58 27.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M51.7 21.2a10.2 10.2 0 0 0-13.9-4l-1.8 1a10.2 10.2 0 0 0-4 13.9l9.2 16.5a25 25 0 0 0 12.5-3.4 24 24 0 0 0 7.5-7l-9.5-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B575B",
    d: "M40.4 31.2c.3.6.3 1.3 0 1.5-.4.2-1-.1-1.4-.7-.3-.7-.3-1.3 0-1.5.5-.2 1 0 1.4.7ZM48 27c.3.6.3 1.2 0 1.4-.4.2-1 0-1.4-.7-.3-.6-.3-1.3.1-1.5.4-.2 1 .1 1.3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "m44.3 28 3.9 4.8-3.6 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B575B",
    d: "M50 36.8a1.3 1.3 0 0 1-2 1.5 1.3 1.3 0 1 1 2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M35 30.3s.6-2.4 3.8-2.6M43.7 24.8s.8-2.5 4.2-1.8M46 44.9c1.4.4 3 .5 4.5.4a7 7 0 0 0 4-2.2c.7-1.3 1.3-2.6 1.7-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M23.7 38.4A24 24 0 0 1 52 12c5 1 9.5 3.3 13 7a24.1 24.1 0 0 0-43.4-8.3 24 24 0 0 0 2.6 30.6l-.5-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M80.7 51.9c6-.7 10.2-6.7 9.4-13.4-.7-6.7-6.1-11.6-12-11-6 .7-10.2 6.7-9.5 13.4.7 6.7 6.2 11.6 12.1 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M105 30.7c-5-1.1-10.2-1.7-15.3-1.7-9.5-.3-15.1.7-16.9 5.4-1.8 4.7-1.4 12.3 4.5 14.8 3.2 1.4 8 .6 11.5-.2s12-4.3 14.8-8.6c2.7-4.3 2.7-7.7 1.4-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M115 38s-3.2-5.7-9-7.3c-6-1.5-11.3 2.3-13.7 6-2.4 3.8-1.3 5-1.3 5s8.5-4.3 13-5c4.4-.9 11 1.3 11 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M90.7 45.5s-1.3-4 4.2-9c5.6-5.2 15.8-3.3 19 .1 3.3 3.4 3 9.4.4 12.4-1.5 1.6-3.3 3-5.3 3.8 0 0-5.2-8.8-18.3-7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M86.1 53.3s2.2-5.6 4.6-7.8c2.5-2.2 10-3 15.6-1.1s4.6 8.3 3.5 10.3c-1 2-4.2 3.6-4.2 3.6l-19.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M86.8 52.4c-1 .2-1.7.7-2.3 1.4-1 1.2-2.3 2.2-3.8 3-2.2 1.3-4.6 1.3-3.8 3.7 1 2.4 4.3 2 6 1.7 1.6-.4 2.2-1 3.5-2 1.3-1 2.2-7.7 2.2-8 0-.3-1.8.2-1.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M92.7 50.1s-3.3-.7-5 .6c-1.6 1.3-1.5 6.4-1.3 9.6 0 3.1 1.2 5.6 2.4 6a3.1 3.1 0 0 0 3-.3c.4-.5 0-5 .2-8.8l.7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M92.7 50.1c-1 2.4-1.6 4.9-2 7.4-.3 3.7 1.7 8.7 2.5 9.2.7.4 3 .3 3.5-.8.4-1.1 0-4.9.1-7 .1-2.3 1.2-7 1-8.5-.1-1.4-3.4-1.6-5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M97.8 50.4s2-1 3.5-.1c1.4.8 1.8 3 1.6 4-.2 1-1 7.4-1.4 9-.4 1.5-1.6 2.2-2.6 2.2-1-.1-1.6-1.3-1.7-2.7l-.4-4 1-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M102.9 52.3c1.2.3 2.3.7 3.5 1.2.7.5 1 2.3.5 5s-1.3 4.2-2.6 4.4c-1.2 0-2.2-1.5-2.2-2.4 0-1 1-6 .8-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FF",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M67.2 54.3c1.7 2.8 1 6.2-1.3 7.7-2.5 1.5-5.8.5-7.5-2.3-1.7-2.7-1-6.1 1.3-7.6 2.5-1.5 5.8-.5 7.5 2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B575B",
    d: "M54 63.5c1.1 2 .7 4.3-1 5.4-1.7 1-4 .3-5.3-1.6-1.2-1.9-.7-4.3 1-5.4 1.6-1 4-.3 5.2 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCC0C0",
    stroke: "#4B575B",
    strokeMiterlimit: 10,
    d: "M64.8 68c1.2 2 .7 4.4-1 5.4-1.6 1-4 .4-5.2-1.5-1.2-2-.8-4.3 1-5.4 1.6-1 4-.3 5.2 1.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h224v216H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceMan);
export default __webpack_public_path__ + "static/media/space-man.3eff8dc452130b9224869dad708bcc4b.svg";
export { ForwardRef as ReactComponent };